export default () =>({
    expanded: false,
    init() {

    }
})